import Animation from '@creditflowresearch/uilib/Animation';
import styles from './intro.module.scss';

const params = {
  factor: 0.04,
  variation: 0.0006,
  amplitude: 500,
  lines: 19,
  waveColor: { r: 255, g: 255, b: 255, a: 0.1 },
  lineStroke: 1,
  speed: 0.0010,
};

const IntroTemplate = () => (
  <div className={ styles.intro } data-test="introSection">
    <div className={ styles.introContainer }>
      <div className={ styles.introContent }>
        <h1 className={ styles.introTitle }>
          <div className={ styles.title }>
            Supersonic insights and analysis for
          </div>
          <div className={ styles.title }>
            Debt Capital Markets
          </div>
        </h1>
        <div className={ styles.introDescription }>
          <p className={ styles.description }>
            CreditFlow is the first word in new issue pricing across US fixed income markets. Harness <br />
            robust datasets, dynamic charting and expert commentary, thoughtfully organized and delivered in real-time.
          </p>
        </div>
      </div>
    </div>
    <Animation parameters={ params } />
  </div>
);

export default IntroTemplate;
